module.exports = "<mat-form-field class=\"w-100-p\">\n  <mat-select [(ngModel)]=\"selectedCostOption\" placeholder=\"Cost Option\" name=\"costOption\"\n      (selectionChange)=\"costSelection()\" required>\n      <mat-option *ngFor=\"let option of costOptions\" [value]=\"option.value\">\n          {{option.viewValue}}\n      </mat-option>\n  </mat-select>\n</mat-form-field>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/common/cost-option-dropdown/cost-option-dropdown.component.html
// module id = ../../../../../src/app/main/content/apps/common/cost-option-dropdown/cost-option-dropdown.component.html
// module chunks = main